<template lang="pug">
  .container
    .columns.has-text-centered
      .column
        .field
          label.label Observación
            .control.has-icons-left.has-icons-right
              textarea.textarea.is-primary(
                type='text', 
                placeholder='Observacion',
                v-model="observacion"
              )
    .columns.is-mobile.v-centered
      .column.is-3
        label.label Estado
      .column.is-9
        .field
          .control
            .select.is-primary.is-rounded
              select(v-model="estado")
                option(value="1") On
                option(value="0") Off
    .columns.has-text-centered.footer
      .column
        a.button.is-black.is-rounded(@click="registrar")
          | Registrar
</template>

<script>
  export default {
    name: 'Formulario',
    data() {
      return {
        estado: '1',
        observacion: ''
      }
    },
    methods: {
      registrar() {
        console.log('Registrar')
      }
    },
  }
</script>

<style scoped>
.footer {
  margin-bottom: 20px;
}
</style>


// WEBPACK FOOTER //
// src/components/codigosQR_Componentes/components/Formulario.vue